module.exports = __webpack_public_path__ + "media/application/images/cyber-forum/twitter-dark-495074fe8da102db5c47c3bae5a032f2.svg";